import http from "../../../NetworkServices/http";
// import axios from "axios";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class OnboardingNetworkService {
  public static getOnboardingConfig(data: any) {
    const { limit, offset } = data;
    const url = `${consoleBaseUrl}${Endpoints.GET_WHATSAPP_CONFIG}`;
    const headers = data.HEADERS;
    const params = { limit, offset };
    return http.get(url, { headers, params });
  }

  public static updateWhatsappProfile(data: any) {
    const url = `${consoleBaseUrl}${Endpoints.GET_WHATSAPP_CONFIG}`;
    return http.post(url, data);
  }

  public static postRegisterOnboarding(data: any) {
    // const { limit, offset, data } = payload;
    const url = `${consoleBaseUrl}${Endpoints.POST_REGISTER_ONBOARDING}`;
    return http.post(url, data);
  }

  public static postPinnacleRegisterOnboarding(data: any) {
    const url = `${consoleBaseUrl}${Endpoints.PINNACLE_POST_REGISTER_ONBOARDING}`;
    return http.post(url, data);
  }

  public static postFacebookLeadFormOnboarding(data: any) {
    // const { limit, offset, data } = payload;
    const url = `${consoleBaseUrl}${Endpoints.FACEBOOK_LEAD_FORM}`;
    return http.post(url, data);
  }

  public static updateBusinessInfo(data: any) {
    const url = `${consoleBaseUrl}${Endpoints.UPDATE_BUSINESS_INFO}`;
    return http.post(url, data);
  }

  public static updateComplianceInfo(data: any) {
    const url = `${consoleBaseUrl}${Endpoints.UPDATE_BUSINESS_COMPLIANCE_INFO}`;
    return http.post(url, data);
  }
}

//*Onboarding *//
class Endpoints {
  static POST_REGISTER_ONBOARDING = "/workspace/whatsapp/auth/callback";
  static PINNACLE_POST_REGISTER_ONBOARDING = "/workspace/whatsapp/pinnacle/auth/callback";
  static FACEBOOK_LEAD_FORM = "/workspace/meta/lead-form/auth/callback";
  static GET_WHATSAPP_CONFIG = "/workspace/whatsapp/config";
  static UPDATE_BUSINESS_COMPLIANCE_INFO = "/workspace/whatsapp/update-business-compliance-info";
  static UPDATE_BUSINESS_INFO = "/workspace/whatsapp/update-business-info";
}